var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalculate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16C0.5 17.1 1.4 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V2C18.5 0.9 17.6 0 16.5 0ZM10.53 4.06L11.59 3L13 4.41L14.41 3L15.47 4.06L14.06 5.47L15.47 6.88L14.41 7.94L13 6.54L11.59 7.95L10.53 6.89L11.94 5.48L10.53 4.06ZM3.75 4.72H8.75V6.22H3.75V4.72ZM9 13H7V15H5.5V13H3.5V11.5H5.5V9.5H7V11.5H9V13ZM15.5 14.25H10.5V12.75H15.5V14.25ZM15.5 11.75H10.5V10.25H15.5V11.75Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16C0.5 17.1 1.4 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V2C18.5 0.9 17.6 0 16.5 0ZM10.53 4.06L11.59 3L13 4.41L14.41 3L15.47 4.06L14.06 5.47L15.47 6.88L14.41 7.94L13 6.54L11.59 7.95L10.53 6.89L11.94 5.48L10.53 4.06ZM3.75 4.72H8.75V6.22H3.75V4.72ZM9 13H7V15H5.5V13H3.5V11.5H5.5V9.5H7V11.5H9V13ZM15.5 14.25H10.5V12.75H15.5V14.25ZM15.5 11.75H10.5V10.25H15.5V11.75Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalculate);
export default __webpack_public_path__ + "static/media/iconCalculate.2510ebdef4a999ed619c4417624fb7f4.svg";
export { ForwardRef as ReactComponent };